export const setBenefitGrid = (isSidebarOpen:boolean,gridBasedOnSideBarOpen:string,withoutsideBarGrid:string) =>{
    if(isSidebarOpen){
        return gridBasedOnSideBarOpen
      }
      return withoutsideBarGrid
}